<template>
    <div>
      <h3 data-aos="fade-left" >{{ $t('ac_cleaning.condition_of_service_section.title') }}</h3>
      <p data-aos="fade-right" class="sub-text" v-html="$t('ac_cleaning.condition_of_service_section.subtitle')"></p>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        title: 'เงื่อนไขราคาที่โปร่งใส',
        description: `ราคาที่แสดงบนเว็บไซต์ เป็นราคาที่รวมทุกบริการตามรายการข้างต้น ไม่มีค่าใช้จ่ายเพิ่มเติม เว้นแต่พบปัญหาเฉพาะหน้างาน เช่น การเติมน้ำยาแอร์ หรือจุดติดตั้งที่เข้าถึงยาก ซึ่งจะแจ้งลูกค้าก่อนทุกครั้ง`
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';

  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/TransparentPricing.vue